import {queryOptions, useQuery, type UseQueryOptions} from '@tanstack/react-query'

import type {GrubhubOrders} from '@/lib/food-grubhub/foodGrubhubModel'
import {getFoodOrders} from '@/lib/food-grubhub/foodGrubhubPaymentService'
import type {SupportedLocales} from '@/lib/locale/locale'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export function getFoodOrdersQueryKey(params: {locale: SupportedLocales}) {
  return ['food-orders', params.locale] as const
}

export function getFoodOrdersQueryOptions<TData = GrubhubOrders, TError = Error>(
  params: {
    locale: SupportedLocales
    signal?: AbortSignal
  },
  options?: Omit<UseQueryOptions<GrubhubOrders, TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getFoodOrdersQueryKey(params),
    queryFn: async ({signal}) =>
      getFoodOrders({
        signal,
        locale: params.locale,
      }),
    ...NO_REFETCH_OPTIONS,
    ...options,
  })
}

export default function useGrubhubGetFoodOrdersQuery(
  locale: SupportedLocales,
  signal?: AbortSignal,
) {
  return useQuery(
    getFoodOrdersQueryOptions({
      locale,
      signal,
    }),
  )
}
